<div   ng-cloak>
      <itec-form
        name="ctrl.formulari.nom"
        fields="ctrl.formulari.camps"
        ng-model="ctrl.llicencia"
        ng-submit-function="ctrl.formulari.func()"
        errors="ctrl.errors"
        backbutton="true"
        backbuttonfunction="ctrl.back()">
          <div transclude-to="additional-form">
            <div ng-if="ctrl.aplicacions.length>0"
              id="aplicacions"
              class="tcqi--margin-top-20 tcqi--margin-bottom-30">
                <table class="itec-table">
                    <thead>
                      <tr>
                        <th>{{'DEFAULT_NOM' | translate}}</th>
                        <th>{{'DEFAULT_TYK' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr ng-repeat="aplicacio in ctrl.aplicacions">
                        <td>
                          <div ng-repeat="nom in aplicacio.noms">{{nom}}</div>
                        </td>
                        <td ng-if="aplicacio.esitec">
                          <form>
                            <itec-select
                               class="mdl-cell mdl-cell--12-col"
                               property-id="id"
                               property-label="urltyk"
                               list="ctrl.listtyksitec"
                               name="tyk"
                               ng-model="aplicacio.tyk"
                               ng-disabled="true">
                             </itec-simple-list>
                           </form>
                        </td>
                        <td ng-if="!aplicacio.esitec">
                          <form>
                          <itec-select
                             class="mdl-cell mdl-cell--12-col"
                             property-id="id"
                             property-label="urltyk"
                             list="ctrl.listtyks"
                             name="tyk"
                             ng-model="aplicacio.tyk"
                             ng-disabled="true">
                           </itec-simple-list>
                         </form>
                        </td>
                      </tr>

                    </tbody>
                  </table>
              <div>
          </div>
      </itec-form>
</div>
